var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    className: "location_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.792a7 7 0 0 0-7 7c0 2.206 1.336 4.268 3.205 5.888l3.441 2.982a.54.54 0 0 0 .708 0l3.441-2.982C17.664 16.06 19 13.998 19 11.792a7 7 0 0 0-7-7zm-9 7a9 9 0 1 1 18 0c0 3.026-1.81 5.592-3.895 7.399l-3.441 2.982a2.54 2.54 0 0 1-3.328 0l-3.441-2.982C4.81 17.384 3 14.818 3 11.79z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.792a2 2 0 1 1-4 0 2 2 0 0 1 4 0z",
    fill: "currentColor"
  })));
};

export { SvgLocation as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNSIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyIDQuNzkyYTcgNyAwIDAwLTcgN2MwIDIuMjA2IDEuMzM2IDQuMjY4IDMuMjA1IDUuODg4bDMuNDQxIDIuOTgyYS41NC41NCAwIDAwLjcwOCAwbDMuNDQxLTIuOTgyQzE3LjY2NCAxNi4wNiAxOSAxMy45OTggMTkgMTEuNzkyYTcgNyAwIDAwLTctN3ptLTkgN2E5IDkgMCAxMTE4IDBjMCAzLjAyNi0xLjgxIDUuNTkyLTMuODk1IDcuMzk5bC0zLjQ0MSAyLjk4MmEyLjU0IDIuNTQgMCAwMS0zLjMyOCAwbC0zLjQ0MS0yLjk4MkM0LjgxIDE3LjM4NCAzIDE0LjgxOCAzIDExLjc5eiIgZmlsbD0iY3VycmVudENvbG9yIi8+PHBhdGggZD0iTTE0IDExLjc5MmEyIDIgMCAxMS00IDAgMiAyIDAgMDE0IDB6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";